module.exports = __webpack_public_path__ + "img/logo-ahued.7e466ab4.jpg";